function IsConnectedLoading() {
    return (
        <div className='is-connected-loader-wrapper'>
            <span className="is-connected-loader"></span>
        </div>
    );
}

export default IsConnectedLoading;